import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA Service Worker Registration + auto-reload when a new version takes control
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('PWA: Service Worker registered', registration.scope);
        // Check for updates every 60s while the tab is open
        setInterval(() => registration.update().catch(() => {}), 60000);
      })
      .catch(error => {
        console.log('PWA: Service Worker registration failed', error);
      });
    
    // When a new SW takes over (via clients.claim), reload once to pick up the
    // fresh HTML + hashed bundles. Guard against infinite loops.
    let reloadGuard = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloadGuard) return;
      reloadGuard = true;
      console.log('PWA: Controller changed — reloading for fresh bundle');
      window.location.reload();
    });
  });
}

// Build timestamp: 1771953720
